import { useState } from 'react';
import isNil from 'ramda/src/isNil';
import CheckBox from '@components/@core/CheckBox';

const HabitItem = ({ type, habit, status, after, onModal, onUpdate }) => {
    const [checked, setChecked] = useState(!isNil(habit.completed_at));
    const completed = status ? (status.complete / status.total).toFixed(2) * 100 : 0;

    const handleCheck = (id, e) => () => {
        const target = e.target.checked && !checked ? 'completed' : 'incompleted';
        onUpdate(target, id);
        setChecked(e.target.checked);
    };

    const handleModal = () => {
        const payload = { type: 'Task Detail', data: { before: { card: habit, after } } };
        onModal(payload);
    };

    return (
        <div className="core-habit-item d-flex ssm-column align-items-start align-items-sm-center" onClick={handleModal}>
            <div className="d-flex d-flex-1 w-100 pb-0 ssp-b-2">
                <CheckBox id={habit.id} size="regular" checked={checked} onChange={handleCheck(habit.id)} />
                <div className="d-flex-1 ms-4">
                    <p className="dsl-b14 mb-1 text-400">{habit.data.name}</p>
                    <p className="dsl-m12 mb-0 text-400">{type}</p>
                </div>
            </div>
            <div className="d-flex flex-row flex-sm-column ps-0 ssp-l-5">
                <p className="dsl-m12 mb-1 text-400">Assigned</p>
                <p className="dsl-b14 mb-1 ms-0 ssm-l-2 text-400 text-capitalize">{status?.category || 'Manager'}</p>
            </div>
            <div className="d-flex flex-row flex-sm-column ms-3 ssm-l-0 text-end ps-0 ssp-l-5">
                <p className="dsl-m12 mb-1 text-400">Completed</p>
                <p className="dsl-b14 mb-1 ms-0 ssm-l-2 text-400">{completed}%</p>
            </div>
        </div>
    );
};

export default HabitItem;
